module.exports = __webpack_public_path__ + "img/1503104791.81ac8926.jpg";